import React, { useState } from "react";

const Footer = () => {
    return(
        <footer>
        <div class="container">
          <div class="row">
            <div class="col-md-8">
              <span>© 2021 Africa Data Hub. Open Cities Lab is a non-profit organisation DSD: 255-261NPO / PBO (18A): 930067929 <br/>
                The ADH project is Licensed under a Creative Commons Attribution 4.0 International License.</span>
            </div>
          </div>
        </div>
      </footer>
    )
}
export default Footer;